Lesson: Documents without namespace
	Progress: 4/5
	Explanation >>
		Documents without a namespace have
		nodes like `Node name:`
		or `Node name >>`

		This lesson has no namespace.
		Previous lessons may or may not have one.

		They cannot be validated with schemas,
		so everything is valid.
		Validation is left to the application
		that reads the document.
	Title: A valid name
	Tilte: A valid name! :-O
	Tiitle: Valid too!!
		All node names are allowed: Yes, long names too
			And all levels: Another level
				One more level: This is inside the previous one!
